
export const FormSelect = ({
  id,
  name,
  label,
  value,
  disabled,
  onChange,
  onBlur,
  onKeyDown,
  placeholder = null,
  error,
  touched,
  options,
  style,
  isLoading,
}) => {
  const classNames = () => {
    let result = "tw-w-auto tw-min-w-60 tw-px-2 tw-py-1 tw-shadow-sm sm:tw-text-sm focus:tw-outline-none tw-rounded disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ";
    if (error && touched) {
      result += "tw-placeholder-red-300 focus:tw-ring-red-500 focus:tw-border-red-500 tw-border-red-300 tw-border-2 tw-text-red-900 ";
    } else {
      result += "focus:tw-ring-2 focus:tw-ring-indigo-700 focus:tw-border-indigo-700 tw-border tw-border-gray-500 ";
    }
    if (isLoading) {
      result += " tw-opacity-50 disabled:tw-cursor-not-allowed ";
    }

    return result;
  }

  return (
    <>
      <select
        id={id}
        aria-label={label || 'select item'}
        title={label}
        name={name}
        value={value}
        disabled={disabled}
        className={classNames()}
        style={style}
        onKeyDown={onKeyDown}
        onChange={onChange}
        onBlur={onBlur}
      >
        {
          options.map((option, index) => {
            return (
              <option
                key={`${option.name}${option.value}`}
                value={option.value}
                disabled={option.disabled}
                hidden={option.hidden}
              >
                {option.name}
              </option>
            )
          })
        }
      </select>
      {
        error && touched &&
        <span className="tw-px-1 tw-text-sm tw-text-red-800 tw-font-bold">
          {error}
        </span>
      }
    </>
  )
}